import Vue from 'vue';
import Component from 'vue-class-component';
import { EventBus } from '~/utils/eventbus';

@Component({})
export default class StateEditModalComponent extends Vue {
    private selectedSaveChanges: boolean = false;
    private selectedYesChanges: boolean = false;

    constructor() {
        super();
    }

    private saveChanges() {
        this.selectedSaveChanges = true;
        EventBus.$emit(EventBus.BUDGET_REQUEST.DISCARD_CHANGES_MODAL, this.selectedSaveChanges);
    }

    private yesChanges() {
        this.selectedYesChanges = true;
        EventBus.$emit(EventBus.BUDGET_REQUEST.YES_CHANGES_MODAL, this.selectedYesChanges);
    }

    private onClickButton() {
        this.$emit('clickedcanceleditstate', false);
    }
}
